/**
 * @generated SignedSource<<788d52ce1cfcb699bca953123b3d8605>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkWithMeLoadedInquiryButton_userProfile$data = {
  readonly analyticsId: number;
  readonly generalInquiryCtaIsVisible: boolean;
  readonly id: string;
  readonly visitorCanEdit: boolean;
  readonly visitorChatConversation: {
    readonly id: string;
  } | null;
  readonly " $fragmentType": "WorkWithMeLoadedInquiryButton_userProfile";
};
export type WorkWithMeLoadedInquiryButton_userProfile$key = {
  readonly " $data"?: WorkWithMeLoadedInquiryButton_userProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkWithMeLoadedInquiryButton_userProfile">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkWithMeLoadedInquiryButton_userProfile",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "analyticsId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "generalInquiryCtaIsVisible",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ChatConversation",
      "kind": "LinkedField",
      "name": "visitorChatConversation",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorCanEdit",
      "storageKey": null
    }
  ],
  "type": "UserProfile",
  "abstractKey": null
};
})();

(node as any).hash = "899276d92855f58b81ce2451ef26bc28";

export default node;
